import { ZURICH_TIME_ZONE } from "./constants.js";

export function formatUsd(value, maximumFractionDigits = 2) {
  if (!Number.isFinite(Number(value))) return "n/v";
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits,
  }).format(Number(value));
}

export function formatChf(value, maximumFractionDigits = 2) {
  if (!Number.isFinite(Number(value))) return "n/v";
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "CHF",
    maximumFractionDigits,
  }).format(Number(value));
}

export function formatNumber(value, maximumFractionDigits = 2) {
  if (!Number.isFinite(Number(value))) return "n/v";
  return new Intl.NumberFormat("ru-RU", { maximumFractionDigits }).format(Number(value));
}

export function formatPercent(value, maximumFractionDigits = 1) {
  if (!Number.isFinite(Number(value))) return "n/v";
  return `${formatNumber(value, maximumFractionDigits)}%`;
}

export function formatZurichDateTime(value) {
  if (!value) return "n/v";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "n/v";
  return new Intl.DateTimeFormat("ru-RU", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: ZURICH_TIME_ZONE,
  }).format(date);
}

export function clamp(value, min = 0, max = 100) {
  return Math.min(max, Math.max(min, Number.isFinite(Number(value)) ? Number(value) : min));
}

export function lastDefined(values) {
  if (!Array.isArray(values)) return null;
  for (let index = values.length - 1; index >= 0; index -= 1) {
    if (values[index] !== null && values[index] !== undefined && Number.isFinite(Number(values[index]))) {
      return Number(values[index]);
    }
  }
  return null;
}

export function toIsoDate(date = new Date()) {
  return date.toISOString().slice(0, 10);
}
